import { Link } from "@remix-run/react";

import { formatState, formatText } from "#app/utils/format-text.tsx";
import { getCarImgSrc } from "#app/utils/misc.tsx";

import { Button } from "./ui/button.tsx";

export default function CarPreview({
  carsInLocation,
  city,
  state,
}: {
  carsInLocation: any[];
  city: string;
  state: string;
}) {
  const title = `${carsInLocation
    .map((car) => `${formatText(car.maker)} ${formatText(car.model)}`)
    .join(", ")} e outros carros elétricos à venda em ${formatText(
    city,
  )} / ${formatState(state)}`;

  return (
    <div className="flex w-full flex-col items-center justify-between gap-4 rounded-lg bg-background px-4 py-6 shadow-md md:flex-row">
      <div className="flex -space-x-2">
        {carsInLocation.map((car: any) => (
          <img
            key={car.id}
            className="inline-block aspect-square h-24 w-24 rounded-full object-cover ring-2 ring-white"
            src={`https://carregados.com.br/cdn-cgi/image/format=auto,width=96,height=96,fit=cover${getCarImgSrc(car.images[0].id)}`}
            alt={`Foto de um ${car.maker} ${car.model}.`}
          />
        ))}
      </div>
      <div className="flex flex-col md:max-w-lg">
        <h3 className="text-lg font-bold capitalize text-primary">
          Procurando um carro elétrico?
        </h3>
        <h4 className="font-bold capitalize">{title}</h4>
      </div>
      <Button asChild className="flex w-full flex-shrink-0 md:w-fit">
        <Link
          prefetch="intent"
          to={`/carros?cidade=${encodeURIComponent(
            city,
          )}&estado=${encodeURIComponent(state)}`}
        >
          Ver todos
        </Link>
      </Button>
    </div>
  );
}
